/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { createDialogRoute, getDialogInitData } from '@gh/common-shared';
import { DialogInput } from '@gh/core-ui';
import { first, groupBy, mapValues, toPairs } from 'lodash';
import {
  JeOrderDetailsDialogConfig,
  JobEstimateDetailsBusinessService,
} from '../../../resources/job-estimate-details-business.service';
import {
  JeCcOrderDetails,
  JeCcOrderDetailsItem,
  JeCcOrderDetailsOrder,
} from '../../../resources/job-estimate-details.model';
import { JeCcOrderDetailsItemGridDefinition } from './je-cc-order-details-item-grid-definition.service';

@Component({
  selector: 'gh-je-order-details-dialog',
  template: require('./je-cc-order-details-dialog.component.html'),
  styles: [require('./je-cc-order-details-dialog.component.scss')],
  providers: [JeCcOrderDetailsItemGridDefinition],
})
export class JeCcOrderDetailsDialogComponent implements OnInit, DialogInput<JeOrderDetailsDialogConfig> {
  input: JeOrderDetailsDialogConfig;
  details: JeCcOrderDetails;
  orders: JeCcOrderDetailsOrder[];
  items: { [orderNumber: number]: JeCcOrderDetailsItem[] };

  constructor(public gridDefinition: JeCcOrderDetailsItemGridDefinition,
              @Inject(MAT_DIALOG_DATA) public dialogData: any) {

  }

  get jobNumber(): string {
    return this.input.jobNumber;
  }

  get siteAddress(): string {
    return this.input.siteAddress;
  }

  ngOnInit(): void {
    const details: JeCcOrderDetails = getDialogInitData(this.dialogData);
    this.details = details;
    this.items = groupBy(details.orderItems, (item) => item.orderNumber);
    // tslint:disable-next-line:no-non-null-assertion
    this.orders = toPairs(mapValues(this.items, (items) => first(items)!.orderCost))
      .map(([orderNumber, cost]: [string, number]) => ({ orderNumber: Number(orderNumber), cost }));
  }
}

export const jeOrderDetailsDialogRoute = createDialogRoute({
  component: JeCcOrderDetailsDialogComponent,
  init: {
    service: JobEstimateDetailsBusinessService,
    selector: 'initOrderDetailsDialog',
  },
});
